<template>
    <div class="cont">
        <div class="goback cursor" @click="closedel">
            <i class="el-icon-arrow-left"></i>
            <span>返回上一页</span>
        </div>
        <div class="warningicon">
            <img :src="$Localimg('warning.png')" alt="" />
        </div>
        <div class="warntio">
            注销账号后账号将永久失效且不可恢复
        </div>
        <div class="tips">
            1、账号将无法登录;<br/> 2、已购课程、收藏课程等内容无法查看和使用;<br/>  3、个人资料等内容永久失效;<br/>4、账号注销后，所有HR新势力个人产品均将无法登录，且数据和账号信息全部丢失<br/>  5、如果有简历信息和找工作记录，则会同步删除，你将无法使用求职/简历功能。
        </div>
        <div class="flx alc" style="justify-content: center;margin-top: 68px;">
            <el-checkbox v-model="checked">我确认已阅读并了解以上信息，且自愿放弃账号内全部数据、服务 </el-checkbox>
        </div>
        
        <div class="btn" @click="delacc" v-if="checked == true">
            确认注销
        </div>
        <div class="btn dsi" v-else>
            我已清楚注销账号的风险
        </div>
        
    </div>
</template>

<script>
    import {
        delAccount
    } from "@/api/index.js"
    export default {
        data() {
            return {
                checked:false
            }
        },
        created() {
        },
        methods: {
            closedel(){
                this.$emit('col',2)
            },
            delacc() {
                let that = this
                that.$confirm('确定要注销该账号吗?', '友情提醒 ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delAccount().then((res) => {
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            localStorage.removeItem('token')
                            window.location.href = "https://two.hrxsl.com/"
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
        }
    }
</script>

<style scoped>
    .dsi{
        background: #EEEFF6 !important;
        color: #7A7C8B !important;
    }
    .btn{
        width: 275px;
        height: 48px;
        background: #007AFF;
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-weight: 500;
        font-size: 16px;
        color: #fff;
        margin: 20px auto 0;
    }
    .tips{
        font-size: 14px;
        color: #77798D;
        line-height: 30px;
        box-sizing: border-box;
        padding-left: 200px;
        margin-top: 26px;
    }
    .warntio{
        margin-top: 14px;
        font-size: 14px;
        color: #000000;
        text-align: center;
    }
    .cont{
          text-align: left;
    }
    .goback{
      font-weight: 500;
      font-size: 14px;
      color: #999999;
    }
    .warningicon{
        text-align: center;
        margin-bottom: 26px;
    }
    
    .warningicon img{
        width: 40px;
        height: 35px;
    }
</style>